














import {
    Vue,
    Component,
    Prop,
} from "@/shared/vuepack";
import { useThemeStore } from "@/shared/store/theme";
import { BulkUploadFile } from "@/admin/types";

@Component({
    components: {
    }
})
export default class PartnerUserBulkAddErrorModal extends Vue {
    themeStore = useThemeStore();

    @Prop()
    file: BulkUploadFile;
}
